import { Data, Params } from '@angular/router';

import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
  data: Data;
}

export interface State {
  router: RouterReducerState<RouterStateUrl>;
}

export const coreReducers: ActionReducerMap<State> = {
  router: routerReducer,
};
